const thisWeek = []

const today = new Date(Date.now())

const ofWeek = today.getDay()

const addDays = (date, days) => {
  const d = new Date(date)
  d.setDate(d.getDate() + days)
  return d
}

for (let i = 1; i < 6; i++) {
  const offset = (i - ofWeek)

  thisWeek[i - 1] = addDays(today, offset)
}

export default thisWeek
